import React from "react";

import CommonPrintModalPartial from "../../../commons/container/App/PrintModalPartial";

type PrintModalPartialProps = React.ComponentProps<typeof CommonPrintModalPartial>;

const PrintModalPartial = (props: PrintModalPartialProps) => {
  return <CommonPrintModalPartial {...props} isOffline={false} isUsbPrinterConnected={false} />;
};

export default PrintModalPartial;
